import { Link } from 'react-router-dom'
import { LandingNav } from '@/components/landing'

interface BlogPost {
  slug: string
  title: string
  excerpt: string
  date: string
  tag: string
}

const BLOG_POSTS: BlogPost[] = [
  {
    slug: 'introducing-beacon',
    title: 'Introducing Beacon: AI That Writes Like You',
    excerpt: 'Most AI writing tools sound like AI. Beacon is different — it learns your actual voice from your existing posts and generates content that sounds like something you would write.',
    date: '2026-02-02',
    tag: 'Announcement',
  },
  {
    slug: 'how-voice-analysis-works',
    title: 'How Voice Analysis Works',
    excerpt: 'A look at how Beacon analyzes your existing posts to build a voice profile — capturing your tone, vocabulary, topics, and style to generate content that matches.',
    date: '2026-02-02',
    tag: 'Product',
  },
  {
    slug: 'consistent-posting-without-burnout',
    title: 'How to Stay Consistent on X Without Burning Out',
    excerpt: 'Posting consistently is the number one growth lever on X. But doing it manually is exhausting. Here is how to build a sustainable content workflow.',
    date: '2026-02-02',
    tag: 'Guide',
  },
]

const TAG_STYLES: Record<string, string> = {
  Announcement: 'bg-primary-text text-primary-bg',
  Product: 'border border-border text-secondary-text',
  Guide: 'border border-border text-secondary-text',
}

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function BlogPage() {
  return (
    <div className="min-h-screen bg-primary-bg">
      <LandingNav />
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-medium mb-2">Blog</h1>
        <p className="text-secondary-text mb-12">Updates, guides, and thoughts on growing on X.</p>

        <div className="space-y-8">
          {BLOG_POSTS.map((post) => (
            <article key={post.slug} className="border border-border p-6 hover:border-primary-text transition-colors">
              <div className="flex items-center gap-3 mb-3">
                <span className={`text-xs px-2 py-0.5 rounded-full ${TAG_STYLES[post.tag] ?? 'border border-border text-secondary-text'}`}>
                  {post.tag}
                </span>
                <time className="text-xs text-secondary-text">{formatDate(post.date)}</time>
              </div>
              <h2 className="text-lg font-medium mb-2">{post.title}</h2>
              <p className="text-sm text-secondary-text">{post.excerpt}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <Link to="/" className="text-sm text-secondary-text hover:text-primary-text transition-colors">
            &larr; Back to home
          </Link>
        </div>
      </div>
    </div>
  )
}
